module.exports = __webpack_public_path__ + "img/scan.c41ded1b.png";